import { DATE_FORMAT } from 'common/constants';

import { KeyboardDatePickerElement } from 'commonComponents/KeyboardDatePickerElement';

export function ExpirationDate({ disabled = true }) {
    return (
        <KeyboardDatePickerElement
            label={'Activation Expiration (' + DATE_FORMAT + ')'}
            name="expiration_date"
            inputVariant="outlined"
            margin="none"
            slotProps={{ textField: { InputLabelProps: { shrink: true }, placeholder: 'unlimited' } }}
            disabled={disabled}
        />
    );
}
